/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBackpackIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-backpack"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.85 22.8Q4.72 22.8 3.96 22.05Q3.2 21.3 3.2 20.18L3.2 7.63Q3.2 6.15 4.06 5.03Q4.92 3.9 6.28 3.48L6.28 2.52Q6.28 1.98 6.66 1.59Q7.05 1.2 7.6 1.2L8.6 1.2Q9.15 1.2 9.54 1.59Q9.93 1.98 9.93 2.52L9.93 3.2L14.05 3.2L14.05 2.52Q14.05 1.98 14.44 1.59Q14.82 1.2 15.38 1.2L16.4 1.2Q16.95 1.2 17.34 1.59Q17.73 1.98 17.73 2.52L17.73 3.48Q19.07 3.9 19.94 5.03Q20.8 6.15 20.8 7.63L20.8 20.18Q20.8 21.3 20.02 22.05Q19.25 22.8 18.15 22.8ZM13.57 14.35L13.57 15.07Q13.57 15.63 13.96 16Q14.35 16.38 14.9 16.38Q15.45 16.38 15.82 15.99Q16.2 15.6 16.2 15.05L16.2 13.05Q16.2 12.5 15.81 12.11Q15.43 11.72 14.88 11.72L9.1 11.72Q8.55 11.72 8.18 12.1Q7.8 12.47 7.8 13.03Q7.8 13.57 8.19 13.96Q8.57 14.35 9.13 14.35Z" fill={color} />
    </svg>
  );
}
